import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./components/Home";
import MainHeader from "./components/header/mainHeader";
import Footer from "./components/newFooter/Footer";
import Remote from "./components/Remote";
import { Toaster } from "react-hot-toast";

// export const BaseURL = "https://ask-ai.digimonk.website";
export const BaseURL = process.env.REACT_APP_PUBLIC_BASE_URL;

function App() {
  return (
    <Router>
      <MainHeader />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/remote" element={<Remote />} />
        <Route path="/investor/:slug" element={<Home />} />
      </Routes>
      <Toaster position="top-right" reverseOrder={false} />
      <Footer />
    </Router>
  );
}

export default App;
